import { createFileRoute } from '@tanstack/react-router';
import { createRouteConfig } from '../utils/routeGuard';
import { Header } from '@/components/public/Header';
import { BackLink } from '@/components/public/BackLink';
import { Hero } from '@/components/public/howItWorks/Hero';
import { Discover } from '@/components/public/howItWorks/Discover';
import { Import } from '@/components/public/howItWorks/Import';
import { Track } from '@/components/public/howItWorks/Track';
import { Improve } from '@/components/public/howItWorks/Improve';
import { PricingTeaser } from '@/components/public/PricingTeaser';
import { FinalCTA } from '@/components/public/FinalCTA';
import { Footer } from '@/components/Footer';

export const Route = createFileRoute('/howItWorks')({
  component: HowItWorks,
  ...createRouteConfig({
    isPublic: true,
  }),
});

function HowItWorks() {
  return (
    <div className='min-h-screen bog-white text-slate-900'>
      <Header />
      <BackLink />
      <Hero />
      <Discover />
      <Import />
      <Track />
      <Improve />
      <PricingTeaser />
      <FinalCTA />
      <Footer />
    </div>
  );
}
